import { render } from "./promos.vue?vue&type=template&id=26bf382a&scoped=true"
import script from "./promos.vue?vue&type=script&lang=js"
export * from "./promos.vue?vue&type=script&lang=js"

import "./promos.vue?vue&type=style&index=0&id=26bf382a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26bf382a"]])

export default __exports__